import { useEffect } from 'react';

type Props = {
  selector?: string;
  useOutsideScroll?: boolean;
  onClickOutside: () => void;
};

const useOutsideClick = ({ selector, useOutsideScroll, onClickOutside }: Props) => {
  useEffect(() => {
    if (!selector && !useOutsideScroll) {
      return;
    }

    const handleOutClick = (e: MouseEvent) => {
      if (!selector) {
        return;
      }

      const target = e.target as Element;

      const isOutClicked = !target.closest(selector) && !target.closest('#popover');

      if (isOutClicked) {
        onClickOutside();
      }
    };

    const handleScroll = () => {
      onClickOutside();
    };

    if (selector) {
      document.addEventListener('click', handleOutClick);
    }

    if (useOutsideScroll) {
      document.addEventListener('scroll', handleScroll);
      document.addEventListener('wheel', handleOutClick);
    }

    return () => {
      if (!selector && !useOutsideScroll) {
        return;
      }

      if (selector) {
        document.removeEventListener('click', handleOutClick);
      }

      if (useOutsideScroll) {
        document.removeEventListener('scroll', handleScroll);
        document.removeEventListener('wheel', handleOutClick);
      }
    };
  }, [selector, useOutsideScroll, onClickOutside]);
};

export default useOutsideClick;
